import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (jobid) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });
    const paramBody = {
        "cancel": [
            {
                "jobid": jobid
            }
        ]
    }
    const Authorization = UserToken;
    const url = ApiUrl2 + 'upload-cancel';
    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };

    const response = await doFetch(url,argument);
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    return response;
};